export interface FeatureResource {
  type: 'Feature'
  id: string
  name: string
  enabled: boolean
}
